/**
 * Screen D — reveal (`/l/:slug/reveal/:entryId`): server outcome first, then the mechanic renderer with a skip and
 * a persistent textual outcome; win / sponsor-sample / loss screens follow (outcome agent, Bible §4.2 D–F).
 */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const RevealPage = lazyRoute(() => import('./RevealPage'), 'page');

export const revealRoutes: RouteObject[] = [{ path: 'reveal/:entryId', element: <RevealPage /> }];
